module.exports = __webpack_public_path__ + "a905ee89ae7f877244a6f503f0cf0ee7.svg";